// GA4 client id from the _ga cookie ("GA1.1.<random>.<timestamp>" -> "<random>.<timestamp>"). Sent to the
// backend so server-side events (pro_purchased) join this browser's GA4 journey and channel.
export const getGaClientId = () => {
    if (typeof document === 'undefined') return undefined;
    try {
        const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
        if (!match) return undefined;
        const parts = decodeURIComponent(match[1]).split('.');
        return parts.length >= 4 ? `${parts[parts.length - 2]}.${parts[parts.length - 1]}` : undefined;
    } catch {
        return undefined;
    }
};
